/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(WorkGroupsDataService.Id, WorkGroupsDataService);

    WorkGroupsDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class WorkGroupsDataService extends base.BaseDataService<Nema.Crew.Model.WorkGroup> {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "workgroupDataService";

    public get EntityName(): string {
        return "WorkGroup";
    }

    public get EntitiesName(): string {
        return "WorkGroups";
    }

    public deleteRelatedEntities(entity: Nema.Crew.Model.WorkGroup): Promise<void> {
        entity.WorkGroupPersons.forEach(step => (<breeze.Entity><any>step).entityAspect.entityState = this.breeze.EntityState.Deleted);
        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }

    public newWorkGroupPerson(defaultPersonId: number): Nema.Crew.Model.WorkGroupPerson {
        return <Nema.Crew.Model.WorkGroupPerson><any>this.entityManager.createEntity('WorkGroupPerson', <Nema.Crew.Model.WorkGroupPerson>{
            PersonId: defaultPersonId
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/workgroups.dataservice.ts